// The shared half of every tool's table, zh-cn (machine-written, unread — ruling G4).
// Same leaves as en.js; composed under each tool's own table by compose() (@3dp/ui/i18n).
export const SHARED_ZH_CN = {
  back: "全部工具",   // the home link's word; its arrow is the template's (R70: at the phone layout the link shows the arrow alone, this word is its aria-label)
  text: "文字",
  font: "字体",
  dl3mf: "下载 3MF",
  share: "复制链接",
  updating: "计算中…",
  exportFail: "下载失败",
  useFont: (family, mb) => `使用 ${family}（${mb} MB）`,
  pickFromList: "字体列表中的其他字体可能有这些字",   // R83: after the offered family, what it lacks — the list holds the others
  fontFailed: (family) => `无法加载 ${family}——请检查网络连接 · 继续使用当前字体`,
  fontNotOffered: (asked) => `此链接使用的字体 ${asked} 本页没有——改用 Kanit`,
  pick: "选择 SVG 文件",
  reading: "正在读取文件…",
  notSvg: "只支持 SVG 文件——在 Illustrator 中选择“导出为 → SVG”，并先把文字转为轮廓",
  svgTooBig: "文件太大或太精细——请减少点数或合并形状后重新导出 SVG",
  svgEmpty: "此文件中没有填充形状——请先把描边和文字转为轮廓",
  svgBad: "此文件无法读取——不是可用的 SVG",
  readFail: "文件无法读取——请重新选择",
  skipped: {
    background: (n) => `${n} 个背景——已移除`,
    bad: (n) => `${n} 个无法读取的形状——已跳过`,
    clipped: (n) => `${n} 个带剪贴蒙版的形状——整个形状被使用，不被裁剪`,
    hidden: (n) => `${n} 个隐藏部分——未使用`,
    image: (n) => `${n} 个位图——仅矢量形状可用`,
    stroke: (n) => `${n} 条无填充描边——请先转成轮廓`,
    stroked: (n) => `${n} 个带描边的形状——描边宽度未计入`,
    text: (n) => `${n} 个文字元素——请先转成轮廓`,
  },
  badLink: "此链接不可用——已改为打开默认设计",
  newerLink: "此链接来自更新的版本——已改为打开默认设计",
  buildFail: "计算失败——请重新调整数值",
  lineHint: "在浏览器中打开以下载",
  shareNoLogo: "此链接不带标志文件——打开的人需要自行选择 SVG",
  linkNeedsLogo: "此设计使用了文件里的标志，但链接不带该文件——请选择 SVG 文件补上",
  h: "高度（毫米）",
  numHint: (lo, hi) => `请输入 ${lo}–${hi} 之间的数字`,
  percent: (v) => `${Math.round(v * 100)}%`,
  slot: (n) => `第 ${n} 槽`,
  parts: {
    lid: "盖子",
  },
  fits: {
    loose: "宽松",
  },
  finishes: {
    engraved: "雕刻",
  },
  lookNames: {
    filasophy: "Filasophy",
  },
  viewGroup: "查看",
  sources: {
    none: "无",
    svg: "SVG 文件",
    text: "文字",
  },
  mood: {
    all: "全部",
    bold: "粗体",
    cute: "可爱",
    handwritten: "手写",
    neat: "工整",
    tech: "科技",
  },
  problem: {
    "missing-chars": (p) => `此字体缺少这些字符：${p.chars.slice(0, 12).join(' ')}`,
    "text-too-complex": "文字太精细——请减少字符或换字体；无法下载",
  },
  noGl: "此浏览器无法显示 3D，但仍可下载",
  needFileLine: "LINE 内无法下载——请先在浏览器中打开本页，再选择文件",
  undo: "撤销",
  redo: "重做",
  machineNote: "机器翻译，未经人工审校",   // shown by ja/zh pages only ("machine-written, unread")
  // ship 3 piece f (ruling R21): the language switch, its cannot-carry note, and the English-page offer
  langSwitchLabel: "语言",
  switchNoFile: "链接不含上传的文件——切换后需要重新选择",
  offerLine: "用简体中文查看本页",
  offerDismiss: null,
  // the font control and the font sheet (@3dp/ui font-control.js, picker.js — unify-ui ship 4a, moved from name-tag)
  pickFont: "选择字体",
  close: "关闭",
  weight: "字重",
  weightName: (w) => `${w} ${{ 100: '极细', 200: '特细', 300: '细体', 400: '常规', 500: '中等', 600: '半粗', 700: '粗体', 800: '特粗', 900: '极粗' }[w] || ''}`.trim(),
  scriptName: {
    latin: "拉丁",
    thai: "泰文",
    japanese: "日语",
    "chinese-simplified": "简体中文",
    "chinese-traditional": "繁体中文",
    han: "中文/日语",
    other: "其他文字",
  },
  chipRemove: "显示所有文字的字体",
  chipMark: "×",
  noFontForText: "没有字体覆盖这段文字——请换一种文字试试",
  noFontInMood: "此分组没有字体",
  fontLoadFailed: "无法加载——请检查网络连接",
  sample: {
    japanese: "名札",
    "chinese-simplified": "名牌",
    "chinese-traditional": "名牌",
  },
  moreFonts: "更多字体（Google Fonts）",
  backToCurated: "← 推荐字体",
  searchFonts: "搜索字体",
  category: {
    all: "全部",
    "sans-serif": "无衬线",
    serif: "衬线",
    display: "显示",
    handwriting: "手写体",
    monospace: "等宽",
  },
  untested: "尚未打印测试",
  noFontFound: "没有找到字体——请换个词或类别试试",
  catalogLoading: "正在加载字体列表…",
  catalogFailed: "无法加载字体列表——请检查网络连接",
  mb: (mib) => `${mib.toFixed(1)} MB`,
  // the colour control (@3dp/ui colours.js — unify-ui ship 4b, moved from name-tag): the own-colour input, an own colour's caption
  customColor: "自定义…",
  customCaption: "自定义",
};
